export default __webpack_public_path__ + "static/media/PAFI_Summary of GMS July 2022.f5e95fa1.pdf";